import styled from "styled-components";

export const ActivityHistoryFilter = styled.div`
  display: flex;
  flex-direction: row;
  height: 3.2rem;
  padding-left: 2.8rem;
`;
